export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/engine-warpper.worker.4b79f26c.worker.js");
}
